import servicesTypes from './types';
export const initialStates = {
	services: {
		poses: {
			list: {},
			item: {},
			deactive: {},
			edit: {},
			addPose: null,
			update: '',
		},
		packages: {
			list: {},
			item: {},
			products: {},
		},
		summary: {
			total_income: 0,
			packages_income: 0,
			cashback_income: 0,
			sold_coupons_count: 0,
			pos_transactions_count: 0,
			cashback_customers_count: 0,
			visits_count: 0,
			wallet_balance: 0,
		},
	},
};
export default function servicesreducers(state = initialStates, action) {
	switch (action.type) {
		case servicesTypes.SUMMARY.SUCCESS: {
			return {
				...state,
				summary: { ...action?.payload },
			};
		}

		case servicesTypes.UPDATE_POS.SUCCESS: {
			return {
				...state,
				poses: {
					...state.poses,
					update: action?.payload?.msg,
				},
			};
		}

		case servicesTypes.UPDATE_POS.CLEAR: {
			return {
				...state,
				poses: {
					...state.poses,
					update: '',
				},
			};
		}

		case servicesTypes.DEACTIVE_POSES.SUCCESS: {
			return {
				...state,
				poses: {
					...state.poses,
					deactive: { ...action?.payload },
				},
			};
		}
		case servicesTypes.EDIT_POSE.SUCCESS: {
			return {
				...state,
				poses: {
					...state.poses,
					edit: { ...action?.payload },
				},
			};
		}
		case servicesTypes.GET_POSES.SUCCESS: {
			// console.log("Re:GET_POSES",action);
			return {
				packages: {
					...state.services?.packages,
				},
				poses: {
					...state.services?.poses.item,
					list: {
						...action.payload,
					},
				},
			};
		}
		case servicesTypes.GET_POSES.CLEAR: {
			return {
				packages: {
					...state.services?.packages,
				},
				poses: {
					...state.services?.poses.item,
					list: {},
				},
			};
		}

		case servicesTypes.GET_POSES_ITEM.SUCCESS: {
			return {
				...state,
				poses: {
					...state.poses,
					item: { ...action?.payload },
				},
			};
		}

		case servicesTypes.SET_POSES.SUCCESS: {
			return {
				...state,
				poses: {
					...state.poses,
					addPose: { ...action?.payload },
				},
			};
		}

		case servicesTypes.SET_POSES.CLEAR: {
			return {
				...state,
				poses: {
					...state.poses,
					addPose: null,
				},
			};
		}

		case servicesTypes.GET_POSES_ITEM.CLEAR: {
			return {
				...state,
				poses: {
					...state.poses,
					item: {},
				},
			};
		}
		case servicesTypes.GET_PACKAGES.SUCCESS: {
			return {
				...state,
				packages: {
					...state.packages,
					list: { ...action?.payload },
				},
			};
		}
		case servicesTypes.GET_PACKAGES.CLEAR: {
			return {
				...state,
				packages: {
					...state.packages,
					list: {},
				},
			};
		}
		case servicesTypes.GET_PRODUCTS.SUCCESS: {
			return {
				...state,
				packages: {
					...state.packages,
					products: { ...action?.payload },
				},
			};
		}
		default:
			return state;
	}
}
